// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"368":"ac2c191a","552":"84487f9e","565":"3277fa3e","970":"78b7b07c"}[chunkId] + ".chunk.js";
};